import React, { ReactNode } from 'react';
import { Dimmer, Segment } from 'semantic-ui-react';
import styled from 'styled-components';
import { IStyled } from '../../styles/types';
import LoadingSpinner from './LoadingSpinner';

interface IProps extends IStyled {
  loadingText?: string;
  children?: ReactNode;
}

const StyledSegment = styled(Segment)`
  &&& {
    height: 100%;
    margin: 0;
    border: 0;
    border-radius: 0;
    box-shadow: unset;
    background-color: transparent;
    .dimmer {
      background-color: transparent;
    }
  }
`;

const Loader = ({ loadingText, children, className }: IProps) => (
  <StyledSegment className={className}>
    <Dimmer active inverted>
      <LoadingSpinner size="medium">{loadingText}</LoadingSpinner>
    </Dimmer>
    {children}
  </StyledSegment>
);

export default Loader;
